import React from "react";

import { useHistory } from "react-router-dom";
import { PATHS } from "utils/constants";

import View from "./View";

const Component = () => {
  const history = useHistory();

  const onNavigate = (path) => () => {
    history.push(path);
  };

  return (
    <View
      onYes={onNavigate(PATHS.FILE.CONTACTUS)}
      onNo={onNavigate(PATHS.ACCOUNT)}
    />
  );
};

export default Component;
